<template>
<div class="w-full md:w-1/2 mb-16 px-6">
    <div v-if="event.image">
        <span v-if="event.private" class="absolute bg-blue-gradient uppercase m-2 px-2 py-1 text-base rounded">Private Event</span>
        <a href="#" @click.stop.prevent="showEventDetail"><img :src="event.image + '?auto=format&fit=crop&h=619&w=1024'"></a>
    </div>
    <div v-else>
        <a href="#" @click.stop.prevent="showEventDetail"><img alt="" src="/img/hems-event-holder.png"></a>
    </div>
    <div class="flex justify-between">
        <div class="uppercase text-base text-gray-darker" v-if="published">Published</div>
        <div v-else>
            <template v-if="status == 'new'"><span class="text-red text-base uppercase">Draft</span></template>
            <template v-if="status == 'needs review'"><span class="text-red text-base uppercase">In Review</span></template>
        </div>
        <div class="flex relative">
            <button class="flex flex-col mr-2"
                @click.stop.prevent="visitPublicUrl"
                @mouseover="hoverLink = true"
                @mouseleave="hoverLink = false"
                v-if="event.published"
            >
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M11.695 9.04a.562.562 0 00-.725.313.584.584 0 00.307.743c.53.228 1.004.542 1.394.942 1.646 1.684 1.646 4.425 0 6.11l-3.374 3.454a4.08 4.08 0 01-2.984 1.256c-1.144 0-2.176-.457-2.984-1.256-1.646-1.685-1.646-4.425 0-6.11l3.374-3.454a.561.561 0 000-.8.53.53 0 00-.78 0l-3.375 3.455c-2.064 2.113-2.064 5.596 0 7.708A5.234 5.234 0 006.313 23a5.234 5.234 0 003.765-1.599l3.374-3.454c2.064-2.113 2.064-5.596 0-7.709a5.383 5.383 0 00-1.757-1.199" fill="#000"/><path d="M11.695 9.04a.562.562 0 00-.725.313.584.584 0 00.307.743c.53.228 1.004.542 1.394.942 1.646 1.684 1.646 4.425 0 6.11l-3.374 3.454a4.08 4.08 0 01-2.984 1.256c-1.144 0-2.176-.457-2.984-1.256-1.646-1.685-1.646-4.425 0-6.11l3.374-3.454a.561.561 0 000-.8.53.53 0 00-.78 0l-3.375 3.455c-2.064 2.113-2.064 5.596 0 7.708A5.234 5.234 0 006.313 23a5.234 5.234 0 003.765-1.599l3.374-3.454c2.064-2.113 2.064-5.596 0-7.709a5.383 5.383 0 00-1.757-1.199z" stroke="#000" stroke-width=".5"/><path d="M21.437 2.6A5.205 5.205 0 0017.685 1c-1.418 0-2.752.571-3.78 1.6l-3.363 3.457c-2.056 2.114-2.056 5.6 0 7.714.5.515 1.084.915 1.751 1.2a.596.596 0 00.223.029c.222 0 .444-.114.528-.343a.586.586 0 00-.306-.743c-.528-.2-1-.543-1.39-.943-1.64-1.685-1.64-4.428 0-6.114L14.711 3.4c.806-.8 1.834-1.257 2.974-1.257 1.14 0 2.168.428 2.974 1.257 1.64 1.686 1.64 4.429 0 6.114l-3.363 3.457a.563.563 0 000 .8.527.527 0 00.778 0l3.363-3.457c2.084-2.114 2.084-5.6 0-7.714" fill="#000"/><path d="M21.437 2.6A5.205 5.205 0 0017.685 1c-1.418 0-2.752.571-3.78 1.6l-3.363 3.457c-2.056 2.114-2.056 5.6 0 7.714.5.515 1.084.915 1.751 1.2a.596.596 0 00.223.029c.222 0 .444-.114.528-.343a.586.586 0 00-.306-.743c-.528-.2-1-.543-1.39-.943-1.64-1.685-1.64-4.428 0-6.114L14.711 3.4c.806-.8 1.834-1.257 2.974-1.257 1.14 0 2.168.428 2.974 1.257 1.64 1.686 1.64 4.429 0 6.114l-3.363 3.457a.563.563 0 000 .8.527.527 0 00.778 0l3.363-3.457c2.084-2.114 2.084-5.6 0-7.714z" stroke="#000" stroke-width=".5"/></g></svg>
            </button>
            <span v-if="hoverLink" class="bg-grey-light py-1 px-3 absolute pin-r button-duplicate whitespace-no-wrap mr-8">View Published Page</span>
            <button class="flex flex-col"
                @click.stop.prevent="showEventDuplicate"
                @mouseover="hover = true"
                @mouseleave="hover = false"
            >
                <svg height='24px' width='24px'  fill="#000000" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" viewBox="0 0 100 100"><g transform="translate(0,-952.36218)"><path style="font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;text-indent:0;text-align:start;text-decoration:none;line-height:normal;letter-spacing:normal;word-spacing:normal;text-transform:none;direction:ltr;block-progression:tb;writing-mode:lr-tb;text-anchor:start;baseline-shift:baseline;opacity:1;color:#000000;fill:#000000;fill-opacity:1;stroke:none;stroke-width:6;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate;font-family:Sans;-inkscape-font-specification:Sans" d="M 27.6875 5 A 3.0003 3.0003 0 0 0 25 8 L 25 25 L 8 25 A 3.0003 3.0003 0 0 0 5 28 L 5 92 A 3.0003 3.0003 0 0 0 8 95 L 72 95 A 3.0003 3.0003 0 0 0 75 92 L 75 75 L 92 75 A 3.0003 3.0003 0 0 0 95 72 L 95 8 A 3.0003 3.0003 0 0 0 92.3125 5 A 3.0003 3.0003 0 0 0 92 5 L 28 5 A 3.0003 3.0003 0 0 0 27.6875 5 z M 31 11 L 89 11 L 89 69 L 75 69 L 75 28 A 3.0003 3.0003 0 0 0 72.3125 25 A 3.0003 3.0003 0 0 0 72 25 L 31 25 L 31 11 z M 11 31 L 69 31 L 69 89 L 11 89 L 11 31 z " transform="translate(0,952.36218)"></path></g></svg>
            </button>
            <span v-if="hover" class="bg-grey-light py-1 px-3 absolute pin-r button-duplicate">Duplicate</span>
        </div>
    </div>

    <h2 class="text-1xl leading-tight mb-2 mt-1">
        <a class="text-n-gray-dark font-sans no-underline hover:underline" href="#" @click.stop.prevent="showEventDetail">
          {{ event.title }}
        </a>
    </h2>

    <div class="font-sans-italic mb-1 hosted-by" v-if="event.hostName">
        Hosted by <span class="font-sans-bold-italic" v-html="event.hostName"></span>
    </div>

    <div class="text-base mb-5" v-html="event.teaser"></div>

    <div class="uppercase">
        <div class="text-base font-sans-bold">{{ event.start_at | moment('ddd. MMMM DD') }}</div>
        <div class="text-2xl leading-tight font-sans-bold" v-if="event.venue">@</div>
    </div>
    <div class="text-base" v-if="event.venue">
        <div v-if="event.venue.url && event.type !== 'physical'">
            <a target="_blank" v-bind:href="event.venue.url">{{ event.venue.name }}</a><br>
        </div>
        <div v-else>
            {{ event.venue.name }}
        </div>
        {{ event.venue.address_1 }}<br>
        <span v-if="event.venue.city">{{ event.venue.city }}, {{ event.venue.state }} {{ event.venue.zip }}</span>
    </div>

    <div class="text-base">
        {{ event.start_at | moment('h:mm') }}-{{ event.end_at | moment('h:mm A') }}
    </div>
</div>
</template>

<script>
    import messaging from "../../mixins/messaging";

    export default {
        mixins: [messaging],

        props: {
            event: Object
        },
        data: () => ({
            hover: false,
            hoverLink: false,
            showFestivalPicker: false
        }),
        computed: {
            published() {
                return this.event.published;
            },
            status() {
                return this.event.status;
            }
        },
        methods: {
            visitPublicUrl() {
                window.open(this.event.public_url, '_blank');
            },
            duplicateEvent(festivalId) {
                let route = this.$laroute.route("api.events.duplicate", {
                    event: this.event.id
                });

                this.showFestivalPicker = false;
                axios
                    .post(route, {festival_id: festivalId})
                    .then(response => {
                        this.$toasted.show("Event has been duplicated");
                        let event = response.data.data;

                        this.$router.push({
                            name: "events-basics",
                            params: { id: event.id }
                        });
                        window.scroll(0, 0);
                    })
                    .catch(error => {
                        this.displayError(error);
                    });
            },
            showEventDetail() {
                this.$store.dispatch("setActiveEvent", { data: this.event });
                this.$router.push({
                    name: "events-basics",
                    params: { id: this.event.id }
                });
            },
            showEventDuplicate() {
                this.$store.dispatch("setActiveEvent", { data: this.event });
                this.$router.push({
                    name: "events-duplicate",
                    params: { id: this.event.id }
                });
            }
        }
    };
</script>
